import { UserPermissions } from "../enums";
import { DonorRoutes, OrganizationRoutes } from "../routes";
const permissionRedirectionInOrder = {
    [UserPermissions.Ticketing]: OrganizationRoutes.Campaigns,
    [UserPermissions.Donation]: OrganizationRoutes.Campaigns,
    [UserPermissions.Contacts]: OrganizationRoutes.Contacts,
    [UserPermissions.Bank]: OrganizationRoutes.Bank,
    [UserPermissions.Receipt]: OrganizationRoutes.Receipts,
    [UserPermissions.UserManagement]: OrganizationRoutes.Settings,
};
export const getDefaultOrganizationRoute = (userPermissions) => {
    const defaultOrganizationRoute = OrganizationRoutes.Campaigns;
    if (!userPermissions) {
        return defaultOrganizationRoute;
    }
    const redirectionPermission = Object.keys(permissionRedirectionInOrder).find((orderedPermission) => userPermissions.includes(orderedPermission));
    return permissionRedirectionInOrder[redirectionPermission] ?? defaultOrganizationRoute;
};
export const getDefaultDonorRoute = () => {
    return DonorRoutes.DonorPaymentTable;
};
